export default __webpack_public_path__ + "static/media/auth_md.f1acea56.jpg";